var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBoardIcoHwp16(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 0V13L4 16V13H1V0H15ZM2 12H4V3L11.333 1H2V12Z",
    fill: "#0973BA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.63142 11.2825C9.97966 11.1827 10.2622 11.3954 10.2622 11.7578C10.262 12.1199 9.97954 12.494 9.63142 12.594C9.2831 12.6939 9.00079 12.4816 9.00059 12.1196C9.00059 11.7571 9.28298 11.3824 9.63142 11.2825ZM8.29279 4.76494C10.0862 4.09063 11.4319 5.3531 11.4319 5.3531C13.1336 4.8302 12.7236 6.37529 12.7236 6.37529C12.335 6.23428 11.8452 6.32381 11.8318 6.32632C12.1242 9.42735 9.56946 10.3842 9.56946 10.3842C7.20038 11.2234 7.2461 9.28968 7.2461 9.28968C7.09253 7.04555 9.80884 5.89858 9.80884 5.89858C8.87087 5.59617 7.04652 6.57077 7.01611 6.58708C6.8316 5.10368 8.29279 4.76494 8.29279 4.76494ZM10.5542 6.61259C10.5317 6.6197 8.75344 7.18735 8.66171 8.72459C8.66121 8.75033 8.64609 9.90799 9.96936 9.10158C9.96936 9.10158 11.4773 8.01223 10.5542 6.61259ZM9.50845 3.28355C10.7084 2.90771 11.278 4.76052 11.278 4.76052C10.0624 3.71677 8.66171 4.13474 8.66171 4.13474C8.80019 3.4068 9.50845 3.28355 9.50845 3.28355Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoardIcoHwp16);
export default __webpack_public_path__ + "static/media/Board_ico_hwp_16.06afec40371c6c8e310978ce14ef2eec.svg";
export { ForwardRef as ReactComponent };